import { Component, OnInit, ViewChild, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { AgregarNoticiaComponent } from '../agregar-noticia/agregar-noticia.component';
import { NoticiasService } from '../../core/noticias.service';
import { Observable } from 'rxjs/Observable';
import { AuthService } from '../../core/auth.service';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AngularFireStorage } from 'angularfire2/storage';
import { MatSidenav } from '@angular/material';
import { EventosService } from '../../core/eventos.service';
import { Renderer2 } from '@angular/core';

const SMALL_WIDTH_BREAKPOINT = 1100;

@Component({
  selector: 'app-noticias',
  templateUrl: './noticias.component.html',
  styleUrls: ['./noticias.component.css'],
})
export class NoticiasComponent implements OnInit {

  eventos: any;

  @ViewChild('sidenav') sidenav: MatSidenav;

  modalOption: NgbModalOptions = {}; // not null!
  noticias: any;
  noticias$: any;
  formulario: FormGroup;
  maxCom = -3;
  revMax = 3;

  private twitter: any;

  cargarCom = false;

  maxNoticias = 3;
  mensajeMax: string;

  @ViewChild('ventana') ventana;


  constructor(private renderer: Renderer2, private es: EventosService, private storage: AngularFireStorage, public fb: FormBuilder, public snackBar: MatSnackBar, private authService: AuthService, private ns: NoticiasService, private modalService: NgbModal, ) {

  }

  ngOnInit() {

    this.eventos = this.es.getEventosFechaLimit();

    // this.noticias = this.ns.getNoticiasFecha();
    // this.noticias$ = this.ns.getNoticiasFecha();
    this.noticias$ = this.ns.getNoticiasFiltrable();
    // this.ns.limit$.next(this.maxNoticias);
    this.formulario = this.fb.group({
      'texto': ['', [Validators.required, Validators.minLength(1), Validators.maxLength(500)]],
    });
    this.initTwitterWidget();

    this.renderer.listen('body', 'scroll', (event) => {
      // Do something with 'event'
      console.log('scroll detectado');
    });

  }


  get texto() { return this.formulario.get('texto') }

  isScreenSmall(): boolean {
    return window.matchMedia(`(max-width: ${SMALL_WIDTH_BREAKPOINT}px)`).matches;
  }

  initTwitterWidget() {
    this.twitter = (<any>window).twttr = (function (d, s, id) {
      let js: any, fjs = d.getElementsByTagName(s)[0],
        t = (<any>window).twttr || {};
      if (d.getElementById(id)) return t;
      js = d.createElement(s);
      js.id = id;
      js.src = "https://platform.twitter.com/widgets.js";
      fjs.parentNode.insertBefore(js, fjs);

      t._e = [];
      t.ready = function (f: any) {
        t._e.push(f);
      };

      return t;
    }(document, "script", "twitter-wjs"));

    if ((<any>window).twttr.ready())
      (<any>window).twttr.widgets.load();

  }

  ngOnDestroy() {
    this.twitter = null;
  }

  open() {
    this.modalOption.backdrop = 'static';
    this.modalOption.keyboard = false;
    const modalRef = this.modalService.open(AgregarNoticiaComponent, this.modalOption);
    // modalRef.componentInstance.id = this.id;
  }

  toggleOculto(oculto: boolean, noticiaId: string) {
    if (oculto) {
      this.ns.actualizar(noticiaId,
        {
          oculto: false,
        }
      );
    } else {
      this.ns.actualizar(noticiaId,
        {
          oculto: true,
        }
      );
    }
  }

  eliminar(noticia: any) {

    noticia.fotos.forEach(foto => {
      this.storage.ref(foto.path).delete();
    });

    this.ns.eliminar(noticia.id);

    this.snackBar.open('La noticia ha sido eliminada correctamente.', 'CERRAR', {
      duration: 4000
    });
  }

  meGusta(id: string, arreglo: Array<any>, userId: string) {
    console.log(arreglo)
    arreglo.push({
      userId: userId,
      // numero: 3
    });

    this.ns.actualizar(id,
      { megusta: arreglo }
    );
  }

  eliminarMeGusta(id: string, arreglo: Array<any>, userId: string) {
    console.log(arreglo)
    arreglo = arreglo.filter(item => item.userId !== userId)

    this.ns.actualizar(id,
      { megusta: arreglo }
    );
  }

  checkMeGusta(arreglo: Array<any>, userId: string): boolean {
    return arreglo = arreglo.find(item =>
      item.userId == userId
    )
  }


  comentar(id: string, user: any, arreglo: Array<any>, ) {
    this.cargarCom = true;

    var texto_con_espacio = this.texto.value.replace(new RegExp('\n', 'g'), "<br>");

    arreglo.push({
      userId: user.uid,
      photoURL: user.photoURL,
      displayName: user.displayName,
      comentario: texto_con_espacio,
      fecha: new Date().getTime(),
      id: this.ns.crearId()
      // numero: 3
    });

    this.ns.actualizar(id,
      { comentarios: arreglo }
    );

    this.formulario.reset();

    setTimeout(() =>
      this.cargarCom = false, 1000
    );

  }

  eliminarComentario(id: string, arreglo: Array<any>, idNoticia: string) {
    console.log(arreglo)
    arreglo = arreglo.filter(item => item.id !== id)

    this.ns.actualizar(idNoticia,
      { comentarios: arreglo }
    );
  }

  cargarMasNoticias() {
    this.maxNoticias = this.maxNoticias + 3;
  }

  // loadMoreArticles() {
  //   this.maxNoticias = this.maxNoticias + 3;
  // }

  // checkMas(largo: number){
  //   if(largo > this.maxNoticias){
  //     this.maxNoticias +=3;
  //     return true;

  //   } else{
  //     return false;
  //   }
  // }

  // scrollHandler(e) {
  //   if (e === 'bottom') {
  //     console.log('Final de la Página');
  //   }
  // }

  // onScrollDown() {
  //   console.log('scrolled!!')
  //   // this.getMovies()
  // }

  // onScroll(event: any) {

  //   if (((window.innerHeight + window.scrollY + 1) >= document.body.offsetHeight) || ((window.innerHeight + document.documentElement.scrollTop) >= document.body.offsetHeight)) {
  //     console.log('Scolleando!!');
  //   }
  // }


}



// WEBPACK FOOTER //
// ./src/app/modulos/noticias/noticias.component.ts